"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagicVariableParser = void 0;
const interface_1 = require("../../automation_manager/interface");
const magic_variable_interface_1 = require("../../automation_manager/interface/magic_variable.interface");
class MagicVariableParser extends magic_variable_interface_1.MagicVariableParserABC {
    constructor(sysFunctions, passFunctions = []) {
        super();
        this.sysFunctions = sysFunctions;
        this.passFunctions = passFunctions;
        this.sysFunctionMap = sysFunctions.reduce((map, func) => {
            map[func.name] = func;
            return map;
        }, {});
    }
    // clone and freeze globalContext to avoid mutation
    exec(expression, _globalContext) {
        const globalContext = Object.freeze(JSON.parse(JSON.stringify(_globalContext)));
        return this._exec(expression, globalContext);
    }
    // parse expression and return value
    _exec(expression, globalContext) {
        const operatorFunc = this.sysFunctionMap[expression.operator];
        if (this.passFunctions.length && this.passFunctions.includes(operatorFunc)) {
            return null;
        }
        if (!operatorFunc) {
            throw Error(`${expression.operator} not implemented.`);
        }
        const { operands } = expression;
        const args = operands.map(operand => {
            if (typeof operand === 'string') {
                return operand;
            }
            if (operand.type === interface_1.OperandTypeEnums.Literal) {
                return operand.value;
            }
            return this._exec(operand.value, globalContext);
        });
        // global context always pass as first argument
        return operatorFunc(globalContext, ...args);
    }
}
exports.MagicVariableParser = MagicVariableParser;
//# sourceMappingURL=magic_variable_parser.js.map